<template>
  <div class="role_warp">
      <div class="item_warp">
        <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="select()"
        >筛选</el-button
      >
      </div>
    <!-- 头部工具栏 -->
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">理财ID</label>
        <el-input
          v-model="investId"
          placeholder="请输入理财ID"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px"></label>
        <el-date-picker
          v-model="dataTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-top: 10px"
        @click="select()"
        >筛选</el-button
      > -->
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 731px"
      size="mini"
    >
      <el-table-column prop="date" label="日期" width="100">
        <template slot-scope="scope">{{
          happenTimeFun(scope.row.date) == "9999-01-01"
            ? "汇总"
            : happenTimeFun(scope.row.date)
        }}</template>
      </el-table-column>
      <el-table-column prop="investId" label="理财ID" width="100" />
      <el-table-column prop="financialDay" label="理财周期" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.financialDay">{{scope.row.financialDay}}天</div>
        </template>
      </el-table-column>
      <el-table-column prop="allBuyPrice" label="投资总金额" width="110" />
      <!-- <el-table-column prop="allBuyPriceTrx" label="投资总金额TRX" width="120" /> -->
      <el-table-column prop="totalBuyPrice" label="今日买入金额" width="110" />
      <!-- <el-table-column prop="totalBuyPriceTrx" label="今日买入TRX" width="110" /> -->
      <el-table-column prop="totalSalePrice" label="今日卖出金额" width="110" />
      <!-- <el-table-column prop="totalSalePriceTrx" label="今日卖出TRX" width="110" /> -->
      <!-- <el-table-column prop="totalEarn" label="今日收益总金额" width="120" /> -->
      <!-- <el-table-column prop="totalEarnTrx" label="今日收益总TRX" width="120" /> -->
      <el-table-column prop="buyMemberCount" label="购买用户数" width="100" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      loading: false, // 表格加载
      dataTime: ["", ""],
      startDate: "",
      endDate: "",
      investId: "",
      bi: "",
    };
  },
  created() {
    let time = +new Date();
    let time1 = +new Date() - 7 * 24 * 60 * 60 * 1000;
    this.dataTime[0] = this.happenTimeFun(time1);
    this.dataTime[1] = this.happenTimeFun(time);
    console.log(this.dataTime);
  },
  mounted() {
    this.getRoleinfo();
  },
  methods: {
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d;
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getRoleinfo();
    },
    // 获取表单信息
    getRoleinfo() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        startDate: this.dataTime[0],
        endDate: this.dataTime[1],
        investId: this.investId,
        bi: this.bi
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .investDataList(params)
        .then((res) => {
          this.tableData = res;
          // this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
